var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"dashboard-text"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"dashboard-text"},[_vm._v("欢迎进入 彩图奔跑 综合管理平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }